export const REPORT_QUERY_KEY = ['report'] as const;
export const COMBINED_REPORT_QUERY_KEY = ['combinedReport'] as const;
